import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode, mergeProps as _mergeProps } from "vue"

const _hoisted_1 = ["aria-hidden", "aria-label"]
const _hoisted_2 = ["fill", "width", "height"]
const _hoisted_3 = ["fill", "width", "height"]
const _hoisted_4 = ["fill", "width", "height"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("span", _mergeProps(_ctx.$attrs, {
    "aria-hidden": !_ctx.title,
    "aria-label": _ctx.title,
    style: { width: _ctx.sizePx, height: _ctx.sizePx },
    class: ["material-design-icon live-photo-icon", { spin: _ctx.spin }],
    role: "img",
    onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('click', $event)))
  }), [
    (_openBlock(), _createElementBlock("svg", {
      fill: _ctx.fillColor,
      class: "material-design-icon__svg ring",
      width: _ctx.size,
      height: _ctx.size,
      viewBox: "0 0 24 24"
    }, [...(_cache[1] || (_cache[1] = [
      _createElementVNode("path", { d: "M 22,12 C 22,6.46 17.54,2 12,2 10.83,2 9.7,2.19 8.62,2.56 L 9.32,4.5 C 10.17,4.16 11.06,3.97 12,3.97 c 4.41,0 8.03,3.62 8.03,8.03 0,4.41 -3.62,8.03 -8.03,8.03 -4.41,0 -8.03,-3.62 -8.03,-8.03 0,-0.94 0.19,-1.88 0.53,-2.72 L 2.56,8.62 C 2.19,9.7 2,10.83 2,12 2,17.54 6.46,22 12,22 17.54,22 22,17.54 22,12 M 5.47,3.97 C 6.32,3.97 7,4.68 7,5.47 7,6.32 6.32,7 5.47,7 4.68,7 3.97,6.32 3.97,5.47 c 0,-0.79 0.71,-1.5 1.5,-1.5 z" }, null, -1)
    ]))], 8, _hoisted_2)),
    (_openBlock(), _createElementBlock("svg", {
      fill: _ctx.fillColor,
      class: _normalizeClass(["material-design-icon__svg play", { visible: !_ctx.playing }]),
      width: _ctx.size,
      height: _ctx.size,
      viewBox: "0 0 24 24"
    }, [...(_cache[2] || (_cache[2] = [
      _createElementVNode("path", { d: "M 10,16.5 16,12 10,7.5" }, null, -1)
    ]))], 10, _hoisted_3)),
    (_ctx.playing)
      ? (_openBlock(), _createElementBlock("svg", {
          key: 0,
          fill: _ctx.fillColor,
          class: _normalizeClass(["material-design-icon__svg pause", { visible: _ctx.playing }]),
          width: _ctx.size,
          height: _ctx.size,
          viewBox: "0 0 24 24"
        }, [...(_cache[3] || (_cache[3] = [
          _createElementVNode("path", { d: "m 9,9 h 2 v 6 H 9 m 4,-6 h 2 v 6 h -2" }, null, -1)
        ]))], 10, _hoisted_4))
      : _createCommentVNode("", true)
  ], 16, _hoisted_1))
}